var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.liffery.com/liffery/contact.html","target":"_blank"}},[_c('external-link-icon',{staticClass:"header-menuitem-icon",attrs:{"size":"14"}}),_c('span',[_vm._v(" Liffery Contact and Find ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }